(function () {
  function syncMetaConsent() {
    var granted = false;
    try {
      if (
        window.Shopify &&
        window.Shopify.customerPrivacy &&
        typeof window.Shopify.customerPrivacy.marketingAllowed === 'function'
      ) {
        granted = window.Shopify.customerPrivacy.marketingAllowed();
      }
    } catch (e) {}

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: { _meta_consent: granted ? 'granted' : 'denied' }
      })
    }).catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncMetaConsent);
  } else {
    syncMetaConsent();
  }

  document.addEventListener('consentGranted', syncMetaConsent);
  document.addEventListener('consentRevoked', syncMetaConsent);
})();